import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { COMPANY } from "../data";
import { openCookiePreferences } from "../components/CookieBanner";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-serif text-2xl font-light mb-3">{title}</h2>
    <div className="space-y-3 text-foreground/75 font-light leading-relaxed">{children}</div>
  </div>
);

export default function CookiePolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="cookie-policy-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-36 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 text-sm uppercase tracking-wide text-muted-foreground hover:text-foreground mb-10 link-underline" data-testid="back-home">
          <ArrowLeft strokeWidth={1.4} className="w-4 h-4" /> Torna alla Home
        </Link>
        <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-4">Informativa</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mb-12">Cookie Policy</h1>

        <Section title="1. Cosa sono i cookie">
          <p>I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Servono a far funzionare il sito, a migliorarne le prestazioni e a fornire informazioni ai titolari.</p>
        </Section>

        <Section title="2. Tipologie di cookie utilizzati">
          <p><strong>Cookie tecnici/necessari:</strong> indispensabili per il corretto funzionamento del sito. Non richiedono consenso e sono sempre attivi.</p>
          <p><strong>Cookie analitici:</strong> utilizzati, previo consenso, per raccogliere informazioni in forma aggregata sull'utilizzo del sito.</p>
          <p><strong>Cookie di profilazione/marketing:</strong> utilizzati, previo consenso, per creare profili relativi all'utente e mostrare contenuti in linea con le preferenze. Non sono pre-attivati.</p>
        </Section>

        <Section title="3. Gestione del consenso">
          <p>Al primo accesso viene mostrato un banner che consente di accettare tutti i cookie, rifiutarli o personalizzare le preferenze. I cookie di profilazione e analitici non vengono installati senza il tuo consenso.</p>
          <p>Puoi modificare le tue scelte in qualsiasi momento:{" "}
            <button onClick={openCookiePreferences} data-testid="open-cookie-prefs-link" className="underline hover:text-foreground">gestisci le preferenze cookie</button>.
          </p>
        </Section>

        <Section title="4. Gestione tramite browser">
          <p>È inoltre possibile gestire o disabilitare i cookie attraverso le impostazioni del proprio browser. La disabilitazione dei cookie tecnici potrebbe compromettere alcune funzionalità del sito.</p>
        </Section>

        <Section title="5. Titolare">
          <p>{COMPANY.name} — {COMPANY.address}. Per qualsiasi richiesta: {COMPANY.email}.</p>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
